// extracted by mini-css-extract-plugin
export default {"application-cell":"ApplicationIdCell_application-cell__RRr8h","application-cell__paymen-type-icon":"ApplicationIdCell_application-cell__paymen-type-icon__B7G1r"};